import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import type { Datapoint } from "@/types/dataset";

const datapointSchema = z.object({
  name: z.string().min(1, "Name is required"),
});

type DatapointFormProps = {
  onSubmit: (values: z.infer<typeof datapointSchema>) => void;
  initialData?: Datapoint;
};

export const DatapointForm = ({ onSubmit, initialData }: DatapointFormProps) => {
  const form = useForm<z.infer<typeof datapointSchema>>({
    resolver: zodResolver(datapointSchema),
    defaultValues: {
      name: initialData?.name || "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Name</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit">{initialData ? "Update" : "Add"} Datapoint</Button>
      </form>
    </Form>
  );
};
